import { userEmailHydrator } from '../../../fieldOptions/hydrators'
import SettingOptionSelector from './SettingOptionSelector'
export default [
  {
    name: 'User',
    prop: 'user_id',
    type: 'autocomplete',
    references: 'admin/users',
    referenceProp: 'fullname',
    dataHydrator: userEmailHydrator,
    displayProp: 'displayVal'
  },
  {
    name: 'Institution',
    prop: 'institution_id',
    type: 'autocomplete',
    references: 'admin/institutions',
    referenceProp: 'name',
    disabled: true
  },
  {
    name: 'Status',
    prop: 'status',
    type: 'select',
    component: SettingOptionSelector,
    options: [
      {
        name: 'Active',
        value: 'ACTIVE'
      },
      {
        name: 'Transferred',
        value: 'TRANSFERRED'
      },
      {
        name: 'Opted out',
        value: 'OPTED_OUT'
      },
      {
        name: 'Incomplete intake',
        value: 'INCOMPLETE_INTAKE'
      },
      {
        name: 'Refunded',
        value: 'REFUNDED'
      },
      {
        name: 'Canceled',
        value: 'CANCELED'
      }
    ]
  }
]
